import React from 'react';

import useTranslation from '../../hooks/use_translation';
import imgEN from '../../images/components/bioage/bioage-en.png';
import imgSV from '../../images/components/bioage/bioage-se.png';
import SectionHeader from '../framework/sections/section-header';
import Video from '../framework/video';

const BioAgeSection = () => {
	const { language, t } = useTranslation('component_bioage_section');

	return (
		<div className="container bioage-section ">
			<div className="row align-items-center justify-content-between">
				<div className="col-md-5  mb-4 mb-lg-0">
					<div className="row">
						<div className="col-xxl-12">
							<SectionHeader
								headingType="p"
								hideButton={true}
								size="lg"
								subHeadingType="h3"
								subTitle={t('t1')}
								title={t('t2')}
								variant="dark"
							/>
						</div>
					</div>

					<div className="mb-lg-4">
						<p className="sm mb-0">{t('t3')}</p>
					</div>
				</div>
				<div className="col-md-6 p-lg-5 ">
					<div className="rounded-3 o-hidden">
						<Video
							variant="bioage"
							video_mp4={
								'https://cdn.testmottagningen.se/assets/2025/03/10/bioagevideobgtm-684.mp4'
							}
						>
							<img
								alt={t('t1')}
								className="img-fluid mb-0 mb-lg-0"
								src={language === 'sv' ? imgSV : imgEN}
							></img>
						</Video>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BioAgeSection;
